<template>
    <div class="container-fluid">
        <br>
        <router-link to="/planos-periodo" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData" class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active" href="#tabFormulario" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-calendar"></i>
                                Dados do Período
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active" id="tabFormulario">
                            <span v-html="$t('validation.field_required')"></span>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('Nome')}">
                                        <required /> <label>{{$t('attributes.name')}}</label>
                                        <input class="form-control" name="Nome" v-validate="{required: true, max:60}"
                                            :placeholder="$t('words.type_name')" v-model="planoValidade.nome">
                                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" :class="{'is-invalid': errors.has('Vencimento')}">
                                        <required /> <label>Vencimento (dias)</label>
                                        <input v-numericOnly :step="1" min="0" class="form-control" name="Vencimento"
                                            v-validate="{required: true,}" placeholder="vencimento da validade"
                                            v-model="planoValidade.vencimento">
                                        <div class="invalid-feedback help-block error">{{errors.first('Vencimento')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" :class="{'is-invalid': errors.has('Desconto')}">
                                        <required /> <label>Desconto</label>
                                        <input v-numericOnly :step="0.5" min="0" class="form-control" name="Desconto"
                                            v-validate="{required: true}" :placeholder="$t('words.type_description')"
                                            v-model="planoValidade.desconto">
                                        <div class="invalid-feedback help-block error">{{errors.first('Desconto')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                planoValidade: {
                    nome: '',
                    validade: 0,
                    desconto: 0,
                },
                loading: false,
            };
        },

        watch: {
            $route(data) {
                if (this.$route.name === 'plano-validadeEdit') {
                    this.getById('getPlanoValidadeById').then(response => {
                        this.planoValidade = response;
                    });
                } else {
                    this.resetForm();
                }
            }
        },
        beforeMount() {




        },
        mounted() {
            if (this.$route.name === 'plano-validadeEdit') {
                this.getById('getPlanoValidadeById').then(response => {
                    this.planoValidade = response;
                });
            }
        },
        methods: {
            saveData() {
                this.loading = true;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name === 'plano-validadeEdit' ?
                            this.updateData('updatePlanoValidade', this.planoValidade, '/planos-periodo') :
                            this.storeData('storePlanoValidade', this.planoValidade);
                    } else this.loading = false;
                });
            },
        }
    };
</script>